export default __webpack_public_path__ + "static/media/leaf.2ca5a41c.svg";